import styled from "styled-components";

export const PlaceholderCellContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    & ul {
        margin: 0;
    }
`;
